<template>
    <div>
        <p class="head">恭喜您,入驻申请已经通过审核！</p>   
        <p>欢迎您的加入</p> 
        <p>立即体验七鸥鸥商家管理系统的更多功能</p> 
        <p class="body"><el-button type="primary" @click="home">立即体验</el-button></p>
    </div>    
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        home(){
             this.$router.replace('/Home')
        }
    }
}
</script>

<style scoped>
.head{
    margin-top: 8%;
}
.body{
    margin-top: 5%;
}
</style>


// WEBPACK FOOTER //
// src/components/Register/AuditFinish.vue